import env from "@irati/utils/env";
import { SANDBOX, PRODUCTION, E2E } from "@irati/utils/constants/environment";
import getTenantFromPath from "@irati/identity/helpers/getTenantFromPath";
import E2E_SCRIPT_TENANT from "@irati/e2e/constants/e2eScriptTenant";
var DomainHelpers = /** @class */ (function () {
    function DomainHelpers() {
    }
    DomainHelpers.prototype.isE2ESetupScripts = function () {
        return env.ENVIRONMENT_NAME === E2E && getTenantFromPath() === E2E_SCRIPT_TENANT;
    };
    DomainHelpers.prototype.isInternal = function () {
        return getTenantFromPath() === "admin";
    };
    DomainHelpers.prototype.isSandbox = function () {
        return env.ENVIRONMENT_NAME === SANDBOX;
    };
    DomainHelpers.prototype.isDev = function () {
        return getTenantFromPath() === "dev" && env.ENVIRONMENT_NAME !== PRODUCTION;
    };
    DomainHelpers.prototype.isMerchant = function () {
        return getTenantFromPath() === "merchant";
    };
    DomainHelpers.prototype.isGlobal = function () {
        return !getTenantFromPath();
    };
    DomainHelpers.prototype.isTenant = function () {
        return !(this.isInternal() || this.isDev() || this.isMerchant() || this.isGlobal());
    };
    return DomainHelpers;
}());
export default new DomainHelpers();
